module.exports = __webpack_public_path__ + "static/media/triumph.fc107dfb.png";